
import { defineComponent } from "vue";

export default defineComponent({
  name: "widget-1",
  props: {
    widgetClasses: String,
  },
});
